export const SIRET_FIELD_LENGTH = 14;
